import api from './api';

const API = process.env.REACT_APP_BACKEND_URL;

export function fileUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // normalise: accept both '/api/files/<storagePath>' and raw '<storagePath>'
  let p = path.startsWith('/') ? path : `/${path}`;
  if (!p.startsWith('/api/')) p = `/api/files${p}`;
  return `${API}${p}`;
}

export async function uploadImage(file) {
  if (file.size > 6 * 1024 * 1024) throw new Error('Image is too large (max 6MB)');
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post('/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data; // { url, path }
}
